import * as tslib_1 from "tslib";
import { AssetBase } from "@awayjs/core";
import { ShadingMethodEvent } from "@awayjs/renderer";
/**
 * ShadingMethodBase provides an abstract base method for shading methods, used by compiled passes to compile
 * the final shading program.
 */
var ShadingMethodBase = (function (_super) {
    tslib_1.__extends(ShadingMethodBase, _super);
    /**
     * Create a new ShadingMethodBase object.
     */
    function ShadingMethodBase() {
        var _this = _super.call(this) || this;
        _this._textures = new Array();
        _this._owners = new Array();
        _this._counts = new Array();
        return _this;
    }
    /**
     * Cleans up any resources used by the current object.
     */
    ShadingMethodBase.prototype.dispose = function () {
    };
    ShadingMethodBase.prototype.iAddOwner = function (owner) {
        //a method can be used more than once in the same material, so we check for this
        var index = this._owners.indexOf(owner);
        if (index != -1) {
            this._counts[index]++;
        }
        else {
            this._owners.push(owner);
            this._counts.push(1);
            //add textures
            var len = this._textures.length;
            for (var i = 0; i < len; i++)
                owner.addTexture(this._textures[i]);
        }
    };
    ShadingMethodBase.prototype.iRemoveOwner = function (owner) {
        var index = this._owners.indexOf(owner);
        if (this._counts[index] != 1) {
            this._counts[index]--;
        }
        else {
            this._owners.splice(index, 1);
            this._counts.splice(index, 1);
            //remove textures
            var len = this._textures.length;
            for (var i = 0; i < len; i++)
                owner.removeTexture(this._textures[i]);
        }
    };
    /**
     *
     */
    ShadingMethodBase.prototype.iAddTexture = function (texture) {
        this._textures.push(texture);
        var len = this._owners.length;
        for (var i = 0; i < len; i++)
            this._owners[i].addTexture(texture);
    };
    /**
     *
     */
    ShadingMethodBase.prototype.iRemoveTexture = function (texture) {
        this._textures.splice(this._textures.indexOf(texture), 1);
        var len = this._owners.length;
        for (var i = 0; i < len; i++)
            this._owners[i].removeTexture(texture);
    };
    /**
     * Marks the shader program as invalid, so it will be recompiled before the next render.
     *
     * @internal
     */
    ShadingMethodBase.prototype.invalidateShaderProgram = function () {
        this.invalidate();
        this.dispatchEvent(new ShadingMethodEvent(ShadingMethodEvent.SHADER_INVALIDATED));
    };
    /**
     * Copies the state from a ShadingMethodBase object into the current object.
     */
    ShadingMethodBase.prototype.copyFrom = function (method) {
    };
    return ShadingMethodBase;
}(AssetBase));
export { ShadingMethodBase };



// WEBPACK FOOTER //
// ../dist/lib/methods/ShadingMethodBase.js